import { ResponseResultTypeDecorator } from './decorators/response-result-type.decorator';
import { SnapShotFrameItem } from '../domain-models/snap-shot-frame-item';
import { GenericArrayServiceResponse } from './generic-array-service-response';

@ResponseResultTypeDecorator(SnapShotFrameItem)
export class GetSnapShotFrameListResponse extends GenericArrayServiceResponse<SnapShotFrameItem> {

}
